// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__JpIn3","title":"styles_title__r4Kho"};